<template>
  <v-container class="mt-10">

    <v-row justify="space-around">
      <v-card width="400">
        <v-card-title>
          <p style="font-size: x-large; font-weight: bold; color: slategrey">Пожалуйста авторизируйтесь</p>
        </v-card-title>

        <v-card-text class="justify-center">
          <!-- Алерт с тестовыми данными — компактно и по строкам -->
          <v-alert dense outlined type="info" class="mb-4 login-demo">
            <div class="mb-2">
              Для просмотра используйте тестовый доступ:
            </div>

            <ul class="mb-0 pl-4">
              <li>
                <strong>Роль:</strong> RECTOR —
                логин: <code>rector</code>, пароль: <code>rector</code>
              </li>
              <li>
                <strong>Роль:</strong> STUDENT —
                логин: <code>1234567</code>, пароль: <code>student</code>
              </li>
              <li>
                <strong>Роль:</strong> CURATOR —
                логин: <code>kurator</code>, пароль: <code>kurator</code>
              </li>
              <li>
                <strong>Роль:</strong> DECANAT —
                логин: <code>decan</code>, пароль: <code>decan</code>
              </li>
            </ul>
          </v-alert>

          <form class="login" @submit.prevent="authenticateUser">
            <v-text-field
                v-model="login"
                name="login"
                label="Логин"
                required
            ></v-text-field>

            <v-text-field
                name="password"
                label="Пароль"
                v-model="password"
                type="password"
                required
            ></v-text-field>

            <p
                style="color: red"
                v-if="serverError"
            >
              {{serverError}}
            </p>

            <v-btn
                color="info"
                class="mr-4"
                type="submit"
            >
              Войти
            </v-btn>

            <v-btn
                color="info"
                class="mr-4"
                @click="showRegistrationForm"
            >
              Зарегистрироваться
            </v-btn>
          </form>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'LoginView',

    data(){
      return {
        login : "",
        password : ""
      }
    },

    computed: {
      serverError () {
        return this.$store.getters.serverError.message
      }
    },

    methods:{
      showRegistrationForm(){
        this.$router.push('/registration')
      },

      authenticateUser: function () {
        let login = this.login
        let password = this.password
        this.$store.dispatch('login', { login, password })
            .then(() => this.$router.push('/'))
            .catch(err => console.log(err))
      }
    }
  }
</script>

<style scoped>
.login-demo code {
  padding: 0 4px;
  background: rgba(0,0,0,.05);
  border-radius: 4px;
}
</style>